import { enforceNumber } from '../../typing';

/**
 * Converte valores com unidade de medida em PX para REM.
 *
 * @category String
 *
 * @example
 * ```ts
 * import { pxToRem } from '@ids/tools';
 *
 * pxToRem(1)
 * // "0.0625rem"
 * ```
 */
export const pxToRem = (unit: string | number = 0, base = 16): string => {
  const regex = /([0-9]+)/gm;

  const px = typeof unit === 'string' ? enforceNumber(unit.match(regex)?.[0]) : unit;

  return `${px / base}rem`;
};
